<!-- 首页没有任务情况下-组件级 -->
<template>
  <div class='no-data'>
    <img :src='noTask'
         alt='No work' />
    <p class='no-task-desc'>No work to be done!</p>
  </div>
</template>

<script>
import noTask from '@/assets/undergraduate/images/no_task.png'
export default {
  name: '',
  components: {},
  data () {
    return {
      // 首页无数据时图片
      noTask
    }
  },
  computed: {},
  mounted () { },
  methods: {}
}
</script>
<style lang='less' scoped>
img {
  display: block;
  border: none;
}
.no-data {
  padding-top: 80px;
  img {
    margin: 0 auto;
    width: 182px;
    height: 156px;
  }
  .no-task-desc {
    font-size: 16px;
    color: #667483;
    letter-spacing: 0;
    text-align: center;
  }
}
</style>
